removeById = require 'lib/util/array/remove-by-id'
Promise = require 'bluebird'
_ = require 'underscore'

module.exports = class PaginatedLoader
  # server limit for scim resources is 100
  PAGE_SIZE: 50

  constructor: (enterprise, opts = {}) ->
    @enterprise = enterprise
    @filter = opts.filterStringBuilder
    @items = []
    @totalLength = 0
    @lengthOfPending = 0
    @loadAsSelected = false
    @nextPageStartIndex = 1
    @hasNext = true
    @sortField = opts.sortField
    @sortOrder = opts.sortOrder

  _load: (startIndex) ->
    query =
      startIndex: startIndex
      count: @PAGE_SIZE
    query.sortBy = @sortField if @sortField
    query.sortOrder = @sortOrder if @sortOrder
    _.extend(query, @filter.getQuery()) if @filter

    # store promise so we can cancel it
    @_loadPromise = @loadPageOfModels(query)

  _updateItems: (models, { totalResults }, startIndex) ->
    # don't double-load the same index -- should be rare, but e.g. scroll
    # events can fire twice
    return [] unless @nextPageStartIndex == startIndex
    for m in models
      @items.push(m)
    @totalLength = totalResults
    @lengthOfPending = @totalLength - @items.length
    models

  _loadAndUpdateItems: (startIndex) ->
    @_load(startIndex).spread (models, results) =>
      @_updateItems(models, results, startIndex)

  loadNext: ->
    return Promise.resolve([]) unless @hasNext

    @_loadAndUpdateItems(@nextPageStartIndex).tap (models) =>
      @nextPageStartIndex += models.length
      @hasNext = @items.length < @totalLength

  loadAll: (afterEachPage) ->
    return Promise.resolve([]) unless @hasNext

    loads = for nextStartIndex in [@nextPageStartIndex..@totalLength] by @PAGE_SIZE
      @_load(nextStartIndex)
    Promise.all(loads)
      .then (responses) =>
        for [models, results] in responses
          @_updateItems(models, results, @nextPageStartIndex)
          afterEachPage(models)
          @nextPageStartIndex += models.length
        @hasNext = false
        @lengthOfPending = 0
        @loadAsSelected = false
        return

  remove: (model) ->
    newItems = removeById(@items, model)
    diff = @items.length - newItems.length
    if diff
      @items = newItems
      @nextPageStartIndex -= diff
      @totalLength -= diff

  abortLoad: ->
    @_loadPromise?.cancellable().cancel()

module.exports.Members = class MembersLoader extends PaginatedLoader
  constructor: (enterprise, opts = {}) ->
    super enterprise, opts

    @sortField = opts.sortField ? 'fullName'
    @sortOrder = opts.sortOrder ? 'ascending'

  loadPageOfModels: (query) ->
    @enterprise.loadPageOfMembers(query)

module.exports.Organizations = class OrganizationsLoader extends PaginatedLoader
  constructor: (enterprise, opts = {}) ->
    super enterprise, opts

    @sortField = opts.sortField ? 'displayName'
    @sortOrder = opts.sortOrder ? 'ascending'

  loadPageOfModels: (query) ->
    @enterprise.loadPageOfOrganizations(query)

module.exports.PendingOrganizations = class PendingOrganizationsLoader extends PaginatedLoader
  constructor: (enterprise, opts = {}) ->
    super enterprise, opts

  loadPageOfModels: (query) ->
    @enterprise.loadPageOfPendingOrganizations(query)

module.exports.PublicBoards = class PublicBoardsLoader extends PaginatedLoader
  constructor: (enterprise, opts = {}) ->
    super enterprise, opts

    @sortField = opts.sortField ? 'name'
    @sortOrder = opts.sortOrder ? 'ascending'

  loadPageOfModels: (query) ->
    @enterprise.loadPageOfPublicBoards(query)



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/paginated-loaders.coffee